import { useMutation, gql } from '@apollo/client';
import {
  EditarProfessorMutation,
  EditarProfessorMutationVariables,
} from './__generated__/EditarProfessorMutation';

const EDITAR_PROFESSOR_MUTATION = gql`
  mutation EditarProfessorMutation(
    $id_professor: Int!
    $dsc_nome_professor: String
    $dsc_email: String
    $dsc_email2: String
    $dsc_email3: String
    $dsc_num_telefone: String
    $dsc_num_telefone2: String
    $dsc_titulacao: String
    $flag_casa: Boolean
    $dsc_bio: String
    $dsc_link_linkedin: String
    $dsc_link_twitter: String
    $dsc_link_facebook: String
    $dsc_link_lattes: String
    $dsc_link_instagram: String
  ) {
    editarProfessor(
      input: {
        id_professor: $id_professor
        dsc_nome_professor: $dsc_nome_professor
        dsc_email: $dsc_email
        dsc_email2: $dsc_email2
        dsc_email3: $dsc_email3
        dsc_num_telefone: $dsc_num_telefone
        dsc_num_telefone2: $dsc_num_telefone2
        dsc_titulacao: $dsc_titulacao
        flag_casa: $flag_casa
        dsc_bio: $dsc_bio
        dsc_link_linkedin: $dsc_link_linkedin
        dsc_link_twitter: $dsc_link_twitter
        dsc_link_facebook: $dsc_link_facebook
        dsc_link_lattes: $dsc_link_lattes
        dsc_link_instagram: $dsc_link_instagram
      }
    ) {
      id_professor
      id_usuario
      dsc_nome_professor
      dsc_email
      dsc_email2
      dsc_email3
      dsc_num_telefone
      dsc_num_telefone2
      dsc_titulacao
      flag_casa
      dsc_bio
      dsc_link_linkedin
      dsc_link_twitter
      dsc_link_facebook
      dsc_link_lattes
      dsc_link_instagram
    }
  }
`;

const useEditarProfessorMutation = () => {
  return useMutation<EditarProfessorMutation, EditarProfessorMutationVariables>(
    EDITAR_PROFESSOR_MUTATION
  );
};

export { useEditarProfessorMutation };
